exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disclaimer{padding-top:20px}.disclaimer p{font-size:12px;color:#f0f0f0}.disclaimer p:last-child{margin-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-06aec038","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/layouts/Footer.vue
// module id = 713
// module chunks = 1